'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var styleHelper = require('../../helper/styleHelper.js');
var appTypes = require('../../types/appTypes');
var graphicsHelper = require('./../../helper/graphicsHelper');
var propConst = require('../../constants/propConst');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var HorizontalScrollBar = require('../common/HorizontalScrollBar');
var TextParts = require('../common/TextParts');
var util = require('../../helper/util');
var _ = require('underscore');

var Shape = React.createClass({

    getInitialState: function () {
        return {};
    },

    paint: function (props) {
        if (this.fallbackToDiv()) {
            return;
        }
        var color = styleHelper.getBackgroundColor(this.props);
        var canvas = ReactDOM.findDOMNode(this.refs.canvas);
        var w = styleHelper.getWidth(this.props);
        var h = styleHelper.getHeight(this.props);
        var radius = styleHelper.getRadius(this.props);
        var dashMode = styleHelper.parseDashMode(styleHelper.getPropertyValue(this.props, propConst.DASH_MODE));
        //todo :PC上的形状的三角形的旋转方向居然与其它的旋转方向是相反的！！！
        var triangleType = this.props.triangleType;
        if (triangleType === appTypes.RotationAngle.NINETY) {
            triangleType = appTypes.RotationAngle.TWO_HUNDRED_SEVENTY;
        } else if (triangleType === appTypes.RotationAngle.TWO_HUNDRED_SEVENTY) {
            triangleType = appTypes.RotationAngle.NINETY;
        }
        var ctx = canvas.getContext('2d');
        var borderVisible = this.getBorderVisible();
        graphicsHelper.drawShpae(ctx,
            {
                width: w,
                height: h,
                dashMode: dashMode,
                borderType: this.props.shapeBorderType,
                borderVisible: styleHelper.getPropertyValue(this.props, propConst.BORDER_VISIBLE),
                borderColor: styleHelper.getBorderColor(this.props),
                fillColor: color,
                radius: radius,
                borderWidth: styleHelper.getBorderWidth(this.props),
                triangleType: triangleType,
                borderLeft: borderVisible.left,
                borderTop: borderVisible.top,
                borderRight: borderVisible.right,
                borderBottom: borderVisible.bottom
            });
    },

    /***
     * 获取每个边的 border 是否显示
     * @returns {{left: *, top: *, right: *, bottom: *}}
     */
    getBorderVisible: function () {
        return {
            left: this.props.rectangleBorderLeftVisible,
            top: this.props.rectangleBorderTopVisible,
            right: this.props.rectangleBorderRightVisible,
            bottom: this.props.rectangleBorderBottomVisible
        };
    },

    /**
     * 该组件的边框能直接用 css 实现吗？
     * @returns {boolean}
     */
    isThisBorderCanUseCss: function () {
        var dashMode = this.props.dashMode;
        return dashMode !== 'dash-dot-dot' && dashMode !== 'dash-dot';
    },

    doAdjustLinkArea: function () {
        var w = styleHelper.getWidth(this.props);
        var h = styleHelper.getHeight(this.props);
        var plink = $('#' + this.props.controlID + ' .page-link');
        var interactiveLink = $('#' + this.props.controlID + ' .interactive-link');

        if (plink) {
            plink.css({
                width: w,
                height: h
            });
        }
        if (interactiveLink) {
            interactiveLink.css({
                width: w,
                height: h
            });
        }
    },

    componentDidUpdate: function (props) {
        this.paint(props);
        this.doAdjustLinkArea();
    },
    componentDidMount: function (props) {
        this.paint(props);
        $(ReactDOM.findDOMNode(this)).on(appTypes.CUSTOM_EVENT.ON_PROPS_CHANGE, this.onPropsChange).on(appTypes.CUSTOM_EVENT.ON_RESIZE, this.onResize);
    },

    onResize: function () {
        $(ReactDOM.findDOMNode(this.refs.text)).trigger(appTypes.CUSTOM_EVENT.ON_PAINT, [this.props.controlID]);
        this.paint(this.props);
    },

    onPropsChange: function (propName, propValue) {
        var o = {};
        o[propName] = propValue;
        this.setState(o);
    },

    render: function () {
        var text = styleHelper.getText(this.props);
        this.currentW = styleHelper.getWidth(this.props);
        this.currentH = styleHelper.getHeight(this.props);
        var isShowScrollBar = (this.props.shapeBorderType === appTypes.ShapeType.RECTANGLE) && (this.props.verticalScrollbarShow || this.props.horizontalScrollbarShow);
        var verticalScrollBarHeight;
        var horizontalScrollBarWidth;
        var thickness = styleHelper.getBorderWidth(this.props);
        if (text) {
            var textArray = util.Text.delimitToParagraphs(text);
            this.isMultiLineText = textArray.length > 1;
        }
        if (isShowScrollBar) {
            if (this.props.verticalScrollbarShow && this.props.horizontalScrollbarShow) {
                verticalScrollBarHeight = this.currentH - 12 - 2 * thickness - 4;
                horizontalScrollBarWidth = this.currentW - 12 - 2 * thickness - 4;
            }
        }
        var mainBoxStyle = {
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            overflow: 'hidden',
            boxSizing: 'border-box'
        };
        var textStyle = {overflow: 'hidden'};


        var w = styleHelper.getWidth(this.props) - 2;
        var h = styleHelper.getHeight(this.props);
        textStyle.width = w;
        textStyle.height = h;
        // textStyle.lineHeight = styleHelper.getHeight(this.props) + 'px';
        if (this.props.horizontalScrollbarShow) {
            textStyle.height -= 16;
        }
        if (this.props.verticalScrollbarShow) {
            textStyle.width -= 16;
        }
        return (<div
            id={this.props.id}
            style={mainBoxStyle}
            key={this.props.controlID + '-shape'}>
            {this.renderShape()}
            {text &&
                //<p style={{marginTop:0, marginBottom:0,textAlign:'center',overflow: 'hidden'}}>
                //<span style={{width:'100%',height:'100%',textAlign:'center'}}>{text}</span>
                //</p>
            <div style={{width:w,height:h,position: 'absolute',left:1,zIndex:10}}>
                <TextParts ref="text" zIndex={1} {...this.props} partStyle={textStyle}/>

            </div>
                }
            { isShowScrollBar && this.props.horizontalScrollbarShow &&
            <HorizontalScrollBar
                value={util.Int(this.props.horizontalScrollbarProgress)}
                width={horizontalScrollBarWidth}
            />
                }
            {
                isShowScrollBar && this.props.verticalScrollbarShow &&
                <VerticalScrollBar
                    value={util.Int(this.props.verticalScrollbarProgress)}
                    height={verticalScrollBarHeight}
                />
                }
        </div>);
    },

    // 当形状是矩形，并且没有圆角，并且没有边框时，使用 div
    //DON'TFIXME: 这样处理的原因是用户经常使用形状组件作为 tab bar 的背景，在上面放了图标，在 iOS Safari 上可能会导致上面的组件显示不出来！
    fallbackToDiv: function () {
        return this.props.shapeBorderType === 'SbRectangle' && (this.props.borderVisible === false || this.isThisBorderCanUseCss());
    },

    renderShape: function () {
        var shapeStyle = {
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            boxSizing: 'border-box'
        };
        var borderVisible = this.getBorderVisible();

        if (this.props.radiusIsPercent) {
            var length = Math.min(this.props.w, this.props.h);
            //if(this.props.borderVisible)
            //    length = length - this.props.thickness;
            length = length * this.props.radius/200;
            if(this.props.borderVisible){
              length = length + this.props.thickness;
            }else{
                length = length + this.props.thickness * 2;
            }
            shapeStyle.borderRadius = length;
            console.log(shapeStyle.borderRadius);
        } else {
            shapeStyle.borderRadius = this.props.radius;
        }

        // 如果要使用 div，先指定背景色和 border， 这里必须先指定，因为后续会有特殊规则覆盖这里的普遍规则
        if (this.fallbackToDiv()) {
            shapeStyle.backgroundColor = styleHelper.getBackgroundColor(this.props);
            if (this.props.borderVisible) {
                shapeStyle.border = this.props.thickness + 'px ' + this.props.dashMode + ' ' + styleHelper.getBorderColor(this.props);
            }
        }

        if (!borderVisible.top) {
            shapeStyle.borderTopLeftRadius = 0;
            shapeStyle.borderTopRightRadius = 0;
            shapeStyle.borderTop = 'none';
        }

        if (!borderVisible.left) {
            shapeStyle.borderTopLeftRadius = 0;
            shapeStyle.borderBottomLeftRadius = 0;
            shapeStyle.borderLeft = 'none';
        }

        if (!borderVisible.right) {
            shapeStyle.borderTopRightRadius = 0;
            shapeStyle.borderBottomRightRadius = 0;
            shapeStyle.borderRight = 'none';
        }

        if (!borderVisible.bottom) {
            shapeStyle.borderBottomRightRadius = 0;
            shapeStyle.borderBottomLeftRadius = 0;
            shapeStyle.borderBottom = 'none';
        }

        if (this.fallbackToDiv()) { // 矩形
            return (
                <div style={shapeStyle}></div>
            );
        }

        shapeStyle.zIndex = -1;
        return (
            <canvas
                ref="canvas"
                style={shapeStyle}
                onChange={this.paint.bind(this, this.props)}
                width={this.currentW}
                height={this.currentH}/>
        );
    }

});

module.exports = Shape;



// WEBPACK FOOTER //
// ./src/views/Components/Shape.jsx